<template>
  <div>
    <div class="" :class="btnPosition.btnHistoryClass || ''">
      <div
        :class="btnPosition.btnClass || ''"
        :style="btnPosition.btnStyle || ''"
      >
        <button
          class="btn btn-primary wizard-btn next-btn"
          @click="$emit('input')"
        >
          {{ requestButtons.next }}
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    <div class="card card-small mb-4 mt-3">
      <div class="card-body">
        <div class="py-2 px-3">
          <div class="row">
            <div class="col-md-6">
              <h6 class="desc-heading">
                {{ $t("days.off.description.application") }}
              </h6>
              <p class="mt-0">{{ request.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <HistoryMinibus />
    </div>
  </div>
</template>

<script>
import HistoryMinibus from '../HistoryMinibusRequest.vue';

export default {
  name: 'StepOneMinibus',
  components: {
    HistoryMinibus
  },

  props: ['user'],
  data() {
    return {
    };
  },
  computed: {
    request() {
      const requestData = {
        description: this.$t('minibus.request.step.one.description'),
      };
      return requestData;
    },

    requestButtons() {
      const requestBtns = {
        next: this.$t('global.next'),

      };
      return requestBtns;
    },

    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },
};
</script>

<style scoped></style>
